import UltMeta, { Meta } from "@/meta/UltMeta/index";

class ShipNeedState extends UltMeta {
    TO_BE_ASSIGNED = new Meta(1, "待指派");
    PENDING_PROCESSING = new Meta(2, "待处理");
    PROCESSING = new Meta(3, "处理中");
    OWNER_TO_BE_CONFIRMED = new Meta(4, "待货主确认");
    OWNER_CONFIRMED = new Meta(5, "已确认");
    COMPLETED = new Meta(6, "已完成");
}
export const SHIP_NEED_STATE = new ShipNeedState();
class PlatShipNeedState extends UltMeta {
    TO_BE_PUBLISH = new Meta(0, "待发布");
    PUBLISH = new Meta(1, "已发布");
    TO_BE_CONFIRMED = new Meta(4, "待确认");
    END = new Meta(2, "已结束", "color-info");
    CANCELED = new Meta(5, "已取消");
}
export const PLAT_SHIP_NEED_STATE = new PlatShipNeedState();
class GetOrderState extends UltMeta {
    PENDING_PROCESSING = new Meta(0, "处理中");
    CONFIRMED = new Meta(1, "--");
}
export const GET_ORDER_STATE = new GetOrderState();
class Bhs extends UltMeta {
    NOT_PACKAGE = new Meta(0, "否");
    PACKAGE = new Meta(1, "是");
}
export const BHS = new Bhs();
class DialogTitle extends UltMeta {
    ACCPET = new Meta(1, "同意报价");
    FAILD = new Meta(2, "拒绝报价");
    DESPOIT = new Meta(3, "收到定金");
}
export const DIALOG_TITLE = new DialogTitle();
class OrderState extends UltMeta {
    PROCESSING = new Meta(1, "处理中");
    ORDER_ACCEPTANCE_FAILED = new Meta(3, "报价失败");
    SUCCESSFUL_ORDER_ACCEPTANCE = new Meta(4, "报价成功");
    ORDER_CANCELED = new Meta(5, "报价取消");
}
export const ORDER_STATE = new OrderState();

class DepositPaymentMethod extends UltMeta {
    PAY_ONESELF = new Meta(1, "自行支付");
    PAY_ZH = new Meta(2, "黄码港网络货运平台");
    PAY_EASY_SIGN = new Meta(3, "签好运网络货运平台");
}

export const DEPOSIT_PAYMENT_METHOD = new DepositPaymentMethod();

// 货主找船 海事费用
class MaritimeAffairsFee extends UltMeta {
    SHIPPERS_BEAR_UPSTREAM = new Meta(1, "货主承担上游");
    SHIPPERS_BEAR_DOWNSTREAM = new Meta(2, "货主承担下游");
    SHIPPERS_BEAR_BOTH_PORTS = new Meta(3, "货主承担两港");
    SHIPPERS_NOT_RESPONSIBLE = new Meta(4, "货主不承担");
}
export const MARITIME_AFFAIRS_FEE = new MaritimeAffairsFee();
// drainageChannel 是否包含排水槽
class DrainageChannelType extends UltMeta {
    NO = new Meta(0, "否");
    YES = new Meta(1, "是");
}
export const DRAINAGE_CHANNEL_TYPE = new DrainageChannelType();

// 运费结算吨位确认节点
class ConfirmNodeType extends UltMeta {
    AWAITING_DEPARTURE = new Meta(1, "待发航");
    TO_BE_UNLOADED = new Meta(2, "待卸货");
}
export const CONFIRM_NODE_TYPE = new ConfirmNodeType();

// 意向运价类型
class FreightRateType extends UltMeta {
    INDEX_PRICE = new Meta(1, "指数价格");
    PRICE_IS_FIXED = new Meta(2, "一口价");
    CALL_FOR_PRICE = new Meta(3, "电议");
}
export const FREIGHT_RATE_TYPE = new FreightRateType();

// 船主船代
class QuoteIdentity extends UltMeta {
    SHIP_OWNER = new Meta(1, "船主");
    SHIP_AGENT = new Meta(2, "船代");
}
export const QUOTE_IDENTITY = new QuoteIdentity();
